var _desc, _path, _text, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 46",
    "aria-labelledby": titleId,
    fill: "none",
    role: "img",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "1-1145val-title"
  }, "Seat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "1-1145val-title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "1-1145val-descr"
  }, "Presents options for seating")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10C1 5.02944 5.02944 1 10 1H36C40.9706 1 45 5.02944 45 10V42C45 43.6569 43.6569 45 42 45H4C2.34315 45 1 43.6569 1 42V10Z",
    fill: "rgb(241 94 34 / 10%)",
    className: "SeatNormal__StyledPath-sc-qo4pp7-0 fiHmrc"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fill: "#f15e22",
    xmlSpace: "preserve",
    fontSize: 16,
    letterSpacing: "0em",
    textAnchor: "middle",
    dominantBaseline: "middle",
    x: "50%",
    y: "55%"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 40H46V42C46 44.2091 44.2091 46 42 46H4C1.79086 46 0 44.2091 0 42V40Z",
    fill: "#f15e22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10C1 5.02944 5.02944 1 10 1H36C40.9706 1 45 5.02944 45 10V42C45 43.6569 43.6569 45 42 45H4C2.34315 45 1 43.6569 1 42V10Z",
    stroke: "#f15e22",
    strokeWidth: 2,
    className: "SeatNormal__StyledStrokeNormal-sc-qo4pp7-1 einrNH"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeat);
export default __webpack_public_path__ + "static/media/seat.948700dbcacd0d57d9eb5bb1ec9d9f61.svg";
export { ForwardRef as ReactComponent };